import { useAuth } from "../../contexts/useAuth";
import { supabase } from "../../lib/supabase";
import GoogleAccountCompletion from "./GoogleAccountCompletion";

export default function GoogleAccountCompletionWrapper({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return children;
  }

  const handleCompleteRegistration = async (phone) => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('No session found');

      const response = await fetch(
        `${import.meta.env.VITE_REACT_APP_API_URL}/api/user/complete-google-registration`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phone }),
        }
      );

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || 'Failed to complete registration');
      }

      window.location.reload();
    } catch (error) {
      console.error('[GoogleAccountCompletionWrapper] Complete registration error:', error);
      throw error;
    }
  };

  const handleClose = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        await fetch(
          `${import.meta.env.VITE_REACT_APP_API_URL}/api/user/cancel-google-registration`,
          {
            method: 'POST',
            headers: { Authorization: `Bearer ${session.access_token}` },
          }
        );
      }
    } catch (err) {
      console.error('[GoogleAccountCompletionWrapper] Cancel registration error:', err);
    } finally {
    await supabase.auth.signOut({ scope: 'local' });
      window.location.href = '/';
    }
  };


  return (
    <>
      {children}
      {currentUser?.needs_phone && (
        <GoogleAccountCompletion
          onSubmit={handleCompleteRegistration}
          onClose={handleClose}
          userData={currentUser}
        />
      )}
    </>
  );
}